import { render, staticRenderFns } from "./ChooseInspectionRoutePoint.vue?vue&type=template&id=6c2aa390&scoped=true"
import script from "./ChooseInspectionRoutePoint.vue?vue&type=script&lang=js"
export * from "./ChooseInspectionRoutePoint.vue?vue&type=script&lang=js"
import style0 from "./ChooseInspectionRoutePoint.vue?vue&type=style&index=0&id=6c2aa390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2aa390",
  null
  
)

export default component.exports